export default "__VITE_ASSET__CrNgx6ne__ 288w, __VITE_ASSET__DuSA3MkI__ 432w, __VITE_ASSET__X1XNeUvf__ 576w";